import _types from '@/views/events/edit/questions/types'

const types = {}
_types.forEach(item => {
    types[item.id] = item
})

export default $http => {
    return {
        namespaced: true,
        state: {
            items: [],
            is_changed: false,
            deleted: [],
        },
        getters: {
            item: (state) => (id) => {
                return state.items[id];
            },
            length: state => {
                return state.items.length;
            },
            props: (state) => (id) => {
                return state.items[id].props;
            },
            is_changed: state => {
                return state.is_changed
            },
            changed_items: state => {
                let items = []
                state.items.forEach(function (item, index) {
                    if (item.isModify)
                        items.push({...item, index: index})
                });
                return items;
            },
            all: state => state.items,
        },
        mutations: {
            load(state, questions) {
                state.items = [];
                questions.forEach(function (item) {
                    item['type'] = types[item['type']]
                    state.items.push({
                        ...item, isModify: false
                    })
                });
            },
            add(state, question) {
                question['type'] = types[question['type']]
                console.log(question)
                state.items.push(question)
            },
            delete(state, index) {
                state.items.splice(index, 1);
            },

            set_prop_key(state, {index, prop_key, value}) {
                state.items[index].props[prop_key] = value;
                state.items[index].isModify = true;
                state.is_changed = true;
            },
            clone(state, {index}) {
                state.items.push({...state.items[index]});
                state.items[state.items.length - 1].isModify = true;
                state.is_changed = true;
            },

            change_prop(state, {index, name, value}) {
                state.items[index][name] = value;
                state.is_changed = true;
                state.items[index].isModify = true;
            },
            itemSaved(state, {index, id}) {
                state.items[index].isModify = false
                state.items[index].id = id
            }

        },
        actions: {
            // eslint-disable-next-line no-unused-vars
            load({commit, dispatch}, questions) {
                commit('load', questions)
            },

            async add({commit, rootGetters}) {
                commit('add', await $http.postQuestion(rootGetters["event/id"], {
                    type: 'text', cost: 1, answer_comment: '', name: '',  props: {answer_help: '', answers: []}
                }));
            },

            async deleteItem({commit, state, rootGetters}, index) {
                await $http.removeQuestion(rootGetters["event/id"], state.items[index].id)
                commit('delete', {index});
            },


            change_prop({commit}, {index, name, value}) {
                commit('change_prop', {index, name, value});
            },
            set_prop_key({commit}, {index, key, value}) {
                console.log('🐞', index, key, value)
                commit('set_prop_key', {index, prop_key: key, value})
            },

            cloneItem({commit}, {index}) {
                commit('clone', {index})
            },

            save({getters, commit}) {
                //console.log('🎈', getters.changed_items);

                getters.changed_items.forEach(async (item) => {


                    await $http.updateQuestion(item.event_id, item.id, item)
                    console.log(item)
                })


                return {}
                // eslint-disable-next-line no-unreachable
                getters.changed_items.items.forEach(function (item, index) {
                    let formData = new FormData();
                    formData.append('_method', 'PATCH');

                    if (item.id) {
                        formData.append('id', item.id);
                    }

                    formData.append('name', item.name);
                    formData.append('type', item.type);
                    formData.append('order', item.order);

                    formData.append('props', JSON.stringify(item.props));
                    $http.post(`quiz/${item.id}/question`, formData,
                        {
                            headers: {'Content-Type': 'multipart/form-data'},
                            onUploadProgress: (e) => {
                                let ps = (e.loaded * 100) / e.total
                                console.log(ps + '%');
                            },
                        }).then((response) => {
                        //this.$notify.success('Изменения сохранены')

                        commit('itemSaved', {index: item.index, id: response.data.id})
                        console.log(index, ' сохранен...')
                    }).catch(reason => {
                        console.log(reason);
                    })

                })

            }
        },
    }
}